import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import * as styles from './style.module.css';
import fontWeights from '../../../Typography/shared/fontWeights/fontWeights';
import typeSizes from '../../../Typography/shared/typeSizes/typeSizes';
import colors from '../../../Typography/shared/colours/colours';
const InputWithoutRef = ({ type, errorMessage, placeholder, value, hasTrailingIcon, disabled, isErrorState, className, ...commonProps }) => {
    // Derived values
    const isPlaceholder = placeholder && value === '';
    const inputClasses = clsx(styles.input, fontWeights[isPlaceholder ? 'regular' : 'semibold'], typeSizes.body, colors.base, {
        [styles.error]: !!errorMessage || isErrorState,
        [styles.isSearch]: type === 'search',
        [styles.trailingIcon]: hasTrailingIcon && !disabled,
    });
    return Depot.createElement('input', {
        type,
        placeholder,
        value,
        className: inputClasses,
        disabled,
        ...commonProps,
    });
};
const Input = Depot.withRef(InputWithoutRef);
Input.displayName = 'Input';
export default Input;
//# sourceMappingURL=index.js.map